<template>
  <div class="my-0 py-0">
    <ul class="flex flex-col bg-gray-900 flex-1 float-left">
      <li v-for='(item, key) in modes' class="mr-1" :key='key'>
        <button @click='mode = parseInt(key)' :class="makeClasses(parseInt(key))">
          <component :is='item' :size='20' />
        </button>
      </li>
    </ul>

    <div class="flex-none mt-1">
      <transform-actions v-if='mode === 0'
                         :transform='transform'
                         :partutil='partutil'
                         :holder-data='holderData' 
                         :transforms-and-source='transformsAndSource'
                         :selections-data='selectionsData'
                         @add-component='$emit("add-component", $event)'
                         @preview='$emit("preview", $event)'
                         @change-component='$emit("change-component")'
                         @fullscreen='$emit("go-fullscreen-component-edit")'
                         />
      <transform-info class='m-1'
                      :transform='transform'
                      :partutil='partutil'
                      :holder-data='holderData'
                      @edit="$emit('edit')"
                      @instant-edit='onInstantEdit'
                      @instant-add='$emit("instant-add")'
                      @center='$emit("center")'
                      direction='row'>
        <template #info=''>
          <slot name="info" />
        </template>
      </transform-info>


      <position-or-anchor v-if='mode === 1' v-model="value" @change-position="onInputPosition" @change-anchor='onInputAnchor' :variables='variables' />
      <local-or-world-scale v-if='mode === 2' v-model='value' @change-world='onInputScale' @change-local='onInputLocalScale' />
      <local-or-world-rotation v-if='mode === 3' v-model="value" @change-world="onInputRotation" @change-local='onInputLocalRotation' />
      <div v-if='mode === 4' class="h-32" style='overflow-y:auto'>
        <choose-transform-layer v-model='value.layer' @change='onInputLayer' :layers='transformsAndSource.from.layers' />
        <zindex class="my-1" v-model="value.zIndex" @change="onInputZindex" />
        <alpha class="my-1" v-model="value.alpha" @change="onInputAlpha" />
        <value-or-variable-with-label class="my-1" label='Unparent' toggle-position='col' v-model='value.unparent'>
          <template #default=''>
            <toggle-switch class="flex-1" v-model='value.unparent' label=''  @change='onInputUnparent' />
          </template>
        </value-or-variable-with-label>
        <value-or-variable-with-label class="my-1" label='Disabled' toggle-position='col' v-model='value.disabled'>
          <template #default=''>
            <toggle-switch class="flex-1" v-model='value.disabled' label=''  @change='onInputDisabled'/>
          </template>
        </value-or-variable-with-label>
        <value-or-variable-with-label class="my-1" label='Send To Origin' toggle-position='col' v-model='value.sendToOrigin'>
          <template #default=''>
            <toggle-switch class="flex-1" v-model='value.sendToOrigin' label=''  @change='onInputSendToOrigin'/>
          </template>
        </value-or-variable-with-label>
      </div>
      <transform-variables v-if='mode === 5' v-model='variables' :variables-source='transform.variables' :transforms-and-source='transformsAndSource' />
    </div>


  <!--
    <div class="w-full bg-gray-900 text-center flex justify-between p-1 m-0">
      <button @click="previous" class="m-0 bg-gray-700 text-xs text-white hover:text-gray-700 hover:bg-gray-400 w-10 rounded-r cursor-pointer">
        &lt;
      </button>
      
      <span class="bg-text-gray-500 font-bold mb-2 text-md text-center text-white">{{modeLabel}}</span>

      <button @click="next" class="m-0 bg-gray-700 text-xs text-white hover:text-gray-700 hover:bg-gray-400 w-10 rounded-r cursor-pointer">
        &gt;
      </button>
    </div>
  -->
  </div>
</template>
<script>
import TransformActions from '@ui/organisms/TransformActions.vue';
import TransformInfo from '@ui/molecules/TransformInfo.vue';
import TransformVariables from '@ui/atoms/TransformVariables.vue';

import ToggleSwitch from '@ui/atoms/ToggleSwitch.vue';
import ValueOrVariableWithLabel from '@ui/molecules/ValueOrVariableWithLabel.vue';
import LocalOrWorldScale from '@ui/molecules/LocalOrWorldScale.vue';
import PositionOrAnchor from '@ui/molecules/PositionOrAnchor.vue';
import LocalOrWorldRotation from '@ui/molecules/LocalOrWorldRotation.vue';
import Numberer from '@ui/atoms/Numberer.vue';
import Scale from '@ui/atoms/Scale.vue';
import Position from '@ui/atoms/Position.vue';
import Rotation from '@ui/atoms/Rotation.vue';
import Zindex from '@ui/atoms/Zindex.vue';
import Alpha from '@ui/atoms/Alpha.vue';
import ChooseTransformLayer  from '@ui/atoms/ChooseTransformLayer.vue';

import ArrowAll from '@icons/ArrowAll.vue';
import ArrowTopRightBottomLeft from '@icons/ArrowTopRightBottomLeft.vue';
import RotateRight from '@icons/RotateRight.vue';
import Layers from '@icons/Layers.vue';
import BoxShadow from '@icons/BoxShadow.vue';
import AxisArrow from '@icons/AxisArrow.vue';
import Cog from '@icons/Cog.vue';
import IframeVariable from '@icons/IframeVariable.vue';
import Information from '@icons/Information.vue';

export default {
  props:{
    value:{
      type: Object,
      required: true
    },
    variables:{
      type:Array,
      default() {
        return [];
      }
    },
    transform:{
      type:Object,
      required:true
    },
    partutil:{
      type:Object,
      required:true
    },
    holderData: {
      type:Object,
      required:true
    },
    transformsAndSource:{
      type:Object,
      required:true
    },
    selectionsData: {
      type: Array,
      required: true
    }
  },
  data() {

    return {
      mode:0,
      modes:{
        0:Information,
        1:ArrowAll, // Position/Anchor
        2:ArrowTopRightBottomLeft, // World Scale/Local Scale
        3:RotateRight, // Rotation
        4:Cog, // Zindex,Alpha etc.
        5:IframeVariable, // Vars
        //3:Layers, // Zindex
        //4:BoxShadow, // Alpha
      }
    }
  },
  components: {
    //Numberer,
    //Position,
    //Scale,
    //Rotation,
    LocalOrWorldScale,
    LocalOrWorldRotation,
    PositionOrAnchor,
    Alpha,
    ChooseTransformLayer,
    Zindex,
    //ArrowAll,
    //Cog,
    ValueOrVariableWithLabel,
    ToggleSwitch,
    TransformVariables,
    TransformInfo,
    TransformActions
  },
  beforeDestroy() {
    this.$store.commit('setDrawAnchorForTransformId', '');
  },
  methods: {
    next() {
      this.mode += 1;
      this.mode = this.mode % Object.keys(this.modes).length;
    },
    previous() {
      this.mode -= 1;
      if (this.mode < 0) {
        this.mode = Object.keys(this.modes).length - 1;
      }
    },
    onInput(type, nv, ov) {
      this.$emit("change", {type, nv, ov});
    },
    onInputPosition(nv, ov) {
      console.log('_______ ON INPUT POSITION', nv, ov);
      this.onInput("position", nv, ov);
    },
    onInputAnchor(nv, ov) {
      this.onInput("anchor", nv, ov);
    },
    onInputScale(nv, ov) {
      this.onInput("scale", nv, ov);
    },
    onInputLocalScale(nv, ov) {
      this.onInput("localScale", nv, ov);
    },
    onInputRotation(nv, ov) {
      this.onInput("rotation", nv, ov);
    },
    onInputZindex(nv, ov) {
      this.onInput("zindex", nv, ov);
    },
    onInputLayer(nv, ov) {
      this.onInput("layer", nv, ov);
    },
    onInputAlpha(nv, ov) {
      this.onInput("alpha", nv, ov);
    },
    onInputLocalRotation(nv, ov) {
      this.onInput("localRotation", nv, ov);
    },
    onInputUnparent(nv, ov) {
      this.onInput("unparent", nv, ov);
    },
    onInputDisabled(nv, ov) {
      this.onInput("disabled", nv, ov);
    },
    onInputSendToOrigin(nv, ov) {
      this.onInput("sendToOrigin", nv, ov);
    },
    makeClasses(mode) {
      const classes = ['inline-block', 'border', 'rounded-b-lg', 'py-2', 'text-white', 'border-t-0', 'px-1', 'text-xs'];
      if (this.mode === mode) {
        classes.push('bg-gray-800', 'border-gray-900');
      } else {
        classes.push('bg-gray-900', 'border-black', 'hover:bg-gray-800');
      }
      return classes;
    },
    onInstantEdit({component}) {
      console.log('onInstantEdit', component);
      this.$emit('instant-edit', {component});
    }
  },
  watch:{
    mode(nv, ov) {
      console.log('mode',nv,ov);
      if (nv === 1 || ov === 1) {
        this.$store.commit('setDrawAnchorForTransformId', nv ? this.transform.id : '');
      }
    }
  },
  computed: {
    modeLabel() {
      return this.modes[this.mode];
    },
  },
}
</script>
